import React from 'react';

import PropTypes from 'prop-types';
import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
import Row from 'react-bootstrap/Row';
import { Link } from 'react-router';
import { useLocation } from 'react-router';

const TabMenu = ({ tabItems }) => {
    const { pathname } = useLocation();

    return (
        <Row>
            <Col>
                <Nav
                    className="justify-content-center"
                    activeKey={pathname}
                    variant="tabs"
                >
                    {
                        tabItems.map((item) => (
                            <Nav.Item key={item.url}>
                                <Nav.Link
                                    as={Link}
                                    className="link-primary"
                                    eventKey={item.url}
                                    to={item.url}
                                >
                                    { item.title }
                                </Nav.Link>
                            </Nav.Item>
                        ))
                    }
                </Nav>
            </Col>
        </Row>
    );
};

TabMenu.propTypes = {
    tabItems: PropTypes.arrayOf(PropTypes.shape({
        title: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
    })),
};

export default React.memo(TabMenu);
